<template>
	<div
		class="configurator-step configurator-step--validstate"
		:class="{ 'configurator-step--active': stepActive, 'configurator-step--valid': isStepValid }"
		:id="stepName"
		v-if="!isFocusStep(stepName)">
		<div class="configurator-step__content">
			<slot name="title">
				<div class="h5 configurator-step__title">
					<span class="configurator-step__count">{{ getStepInt }}</span>
					{{ title }}
				</div>
			</slot>
			<div class="configurator-step__holder" v-show="stepActive">
				<slot />
				<configurator-navigation-buttons :name="stepName" />
			</div>
		</div>
	</div>
	<div
		class="configurator-step" :class="{ 'configurator-step--active': stepActive }"
		:id="stepName" v-else
		v-show="stepActive">
		<slot name="title">
			<div class="h5 configurator-step__title">
				<span class="configurator-step__count">{{ getStepInt }}</span>
				{{ title }}
			</div>
		</slot>

		<slot />
		<configurator-navigation-buttons :name="stepName" />
	</div>
</template>

<script>
import { Helper } from "@/helpers";
import configuratorNavigationButtons from "@/components/configurator-navigation-buttons";

export default {
	name: "Step",
	components: {
		configuratorNavigationButtons
	},
	data () {
		return {
			firstStepActive: false
		};
	},
	props: {
		name: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		id: {
			type: Number,
			default: null
		},
		"error-message": {
			type: String,
			default: ""
		},
		valid: {
			type: Boolean,
			default: false
		},
		position: {
			type: Number,
			default: null
		}
	},
	computed: {
		stepName () {
			return this.name
				.toLowerCase()
				.replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, "-")
				.replace(/^(-)+|(-)+$/g, "");
		},
		getAllSteps () {
			return this.$store.getters.getAllSteps;
		},
		getCurrentStep () {
			return this.$store.getters.getCurrentStep;
		},
		stepActive () {
			return this.getAllSteps[this.getCurrentStep.index].name === this.stepName;
		},
		configuratorType () {
			return this.$store.getters.getConfiguratorType;
		},
		getConfiguratorTypeString () {
			return this.$store.getters.getConfiguratorTypeString;
		},
		configuratorData () {
			return this.$store.state.configuratorData;
		},
		isConfiguratorDataValid () {
			return this.$store.getters.isConfiguratorDataValid;
		},
		isExistingConfigurationAdded () {
			return this.$store.getters.isExistingConfigurationAdded;
		},
		existingConfigIsFinalized () {
			return this.$store.getters.existingConfigIsFinalized;
		},
		getUploaderPosition () {
			return this.$store.getters.getUploaderPosition;
		},
		getThisStepData () {
			return this.getAllSteps.find(s => s.name === this.stepName);
		},
		checkData () {
			return this.$store.getters.checkData;
		},
		isStepValid () {
			const currentStep = this.stepName;
			const isStepAvailable = step => ({
				"select-product": this.checkData.hasSelectedProduct,
				"select-format": this.checkData.hasSelectedFormat
			})[step];

			const stepIsValid = isStepAvailable(currentStep);

			if (stepIsValid != null) {
				return stepIsValid;
			}

			return this.getThisStepData.valid;
		},
		getStepInt () {
			const step = this.getAllSteps.find(s => s.name === this.stepName);
			return this.getAllSteps.indexOf(step) + 1;
		}
	},
	methods: {
		addStep () {
			const payload = {
				option: {
					name: this.stepName,
					title: this.title,
					errorMessage: this.errorMessage,
					groupId: this.id,
					valid: this.valid ? this.valid : false
				}
			};

			if (this.position !== undefined && this.position !== null) {
				payload.position = this.position;
			}

			this.$store.commit("CONFIGURATOR_ADD_STEP", payload);
		},
		removeStep () {
			const stepToRemove = this.getAllSteps.find(a => a.name === this.stepName).name;

			this.$store.commit("CONFIGURATOR_REMOVE_STEP", stepToRemove);
		},
		isFocusStep (stepName) {
			return ["configurator-overview", "price-table", "uploader"].includes(stepName);
		}
	},
	watch: {
		getConfiguratorTypeString: function (a, b) {
			const typeStringToStep = type => ({
				"upload": "uploader",
				"calculate": this.configuratorData.hasMultipleProducts ? "select-product" : "select-format"
			})[type] || null;

			if (typeStringToStep(a)) {
				const payload = this.$store.getters.getAllSteps.find(s => s.name === typeStringToStep(a));
				this.$store.commit("CONFIGURATOR_SET_ACTIVE_STEP", payload);
			}
		},
		name: function (a, b) {
			function formatStep (input) {
				return input
					.toLowerCase()
					.replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, "-")
					.replace(/^(-)+|(-)+$/g, "");
			}
			const prevStepName = formatStep(b);

			const step = this.$store.getters.getAllSteps.find(x => x.name === prevStepName);
			const stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "name",
				value: formatStep(a)
			});
		},
		title: function (a, b) {
			const step = this.$store.getters.getAllSteps.find(x => x.title === b);
			const stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "title",
				value: a
			});
		},
		id: function (a, b) {
			const step = this.$store.getters.getAllSteps.find(x => x.groupId === b);
			const stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "groupId",
				value: a
			});
		},
		errorMessage: function (a, b) {
			const step = this.$store.getters.getAllSteps.find(x => x.title === b);
			const stepIndex = this.$store.getters.getAllSteps.indexOf(step);

			this.$store.commit("CONFIGURATOR_UPDATE_STEP", {
				index: stepIndex,
				property: "errorMessage",
				value: a
			});
		},
		isConfiguratorDataValid (a, b) {
			if (!a) {
				if (!this.getUploaderPosition.before) {
					this.$store.commit("CONFIGURATOR_REMOVE_STEP", "uploader");
				}

				if (!this.configuratorType.isConfiguration) {
					this.$store.commit("CONFIGURATOR_REMOVE_STEP", "price-table");
				}

				this.$store.commit("CONFIGURATOR_REMOVE_STEP", "configurator-overview");
			}
		}
	},
	mounted () {
		if (this.isConfiguratorDataValid
			&& this.isExistingConfigurationAdded
			&& !this.existingConfigIsFinalized) {
			this.$store.commit("FINAL_STEP_EXISTING_CONFIG");
		}
	},
	created () {
		const firstStep = this.getAllSteps[0];

		this.addStep();

		if (Helper.isEmptyObject(this.getCurrentStep.data)) {
			this.$store.commit("CONFIGURATOR_SET_ACTIVE_STEP", firstStep);
		}

		if (this.getCurrentStep !== undefined && firstStep) {
			this.$store.commit("CONFIGURATOR_STEP_AVAILABLE");
		}

		if (this.setActive) {
			this.$store.commit("CONFIGURATOR_SET_ACTIVE_STEP", {
				name: this.stepName,
				title: this.title,
				errorMessage: this.errorMessage,
				groupId: this.id,
				valid: this.valid ? this.valid : false
			});
		}
	},
	beforeDestroy () {
		const dontRemove = ["configurator-overview", "price-table", "uploader"];
		if (!dontRemove.includes(this.stepName)) {
			this.removeStep();
		}
	}
};
</script>

<style lang="scss">
.configurator-step {
	position: relative;

	.configurator-step__count {
		width: 20px;
	}

	.configurator-step__title {
		position: relative;
		display: flex;
		align-items: center;
		gap: 6px;

		width: 100%;
		padding: 16px 60px 16px 16px;
		margin: 6px 0;
		background: var(--cfg-primary-tint);

		font-size: 2rem;
		line-height: 2.2rem;
		color: var(--cfg-primary-dark);
		border-radius: 8px;
	}

	.configurator-step__count--valid {
		position: relative;
		display: inline-block;
		width: 20px;
		height: 20px;
		border-radius: 10px;
	}

	.configurator-step__count--valid::after {
		content: "";
		position: absolute;
		top: 2px;
		left: 6px;
		width: 5px;
		height: 10px;

		border-color: transparent var(--cfg-primary-dark) var(--cfg-primary-dark) transparent;
		border-style: solid;
		border-width: 2px;

		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.configurator-step__item {
		font-weight: 400;
		color: #1D2939;
		font-size: 1.5rem;
		align-self: flex-end;
	}

	.configurator-step__semi-colon {
		margin-left: -6px;
	}

	&--validstate {
		position: relative;

		.configurator-step__identifier {
			background: var(--cfg-primary-tint-alt);
			border-radius: 8px;
			padding: 16px;
		}

		.configurator-step__title {
			position: relative;
			display: flex;
			align-items: center;
			gap: 6px;
			width: 100%;
			padding: 16px;
			padding-right: 60px;
			margin: 6px 0;

			font-size: 2rem;
			line-height: 2.2rem;
			background: #F9FAFB;
			border-radius: 8px;
			color: #667085;
		}
	}

	&--active {
		.configurator-step__holder {
			padding-top: 10px;
		}
	}

	&--validstate#{&}--valid {
		.configurator-step__title {
			color: var(--cfg-primary-dark);
			background: var(--cfg-primary-tint);
		}

		.configurator-step__line:before {
			max-height: 100%;
		}
	}

	&--validstate#{&}--active {
		.configurator-step__title {
			color: #1D2939;
			background: var(--cfg-primary-tint);
		}

		.configurator-step__count--valid::after {
			border-color: transparent #1D2939 #1D2939 transparent;
		}

		.configurator-step__icon {
			top: -5px;
			height: 30px;
			width: 30px;
			font-size: 18px;
			line-height: 30px;
			background: #505050;
			box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.4);
		}
	}

	&--validstate#{&}--active#{&}--valid {
		.configurator-step__icon {
			background: #43a047 !important;
		}
	}

	&--inline {
		margin-top: 30px;
		padding: 15px;
		background: #e4edf4;
	}
}

.configurator-step__icon {
	display: inline-block;
	position: relative;
	top: -5px;
	height: 30px;
	width: 30px;
	background: #d3d3d3;
	border-radius: 30px;

	font-size: 18px;
	color: white;
	font-weight: 700;
	text-align: center;
	line-height: 30px;

	transition: 0.2s ease;
	z-index: 1;

	&--valid {
		background: var(--cfg-success-dark) !important;
	}
}

.configurator-step__identifier {
	position: relative;
}

.configurator-step__line {
	display: inline-block;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	height: 100%;
	width: 5px;
	margin: auto;
	border-radius: 10px;
	background: #d3d3d3;

	z-index: 0;
	overflow: hidden;

	&:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		height: 100%;
		max-height: 0;
		width: 100%;
		background: var(--cfg-success-dark) !important;
		transition: max-height 0.5s ease;
	}

	&--fade {
		background: linear-gradient(#d3d3d3, #fff 70%);
	}
}

.configurator-step__inner {
	position: relative;
	display: block;
	padding: 15px 20px;

	&--light-blue {
		background: var(--cfg-primary-tint-alt);
		border-radius: 4px;
	}

	&--light-grey {
		background: #f5f5f5;
		border-radius: 4px;
	}

	&--light-grey#{&}--valid,
	&--light-blue#{&}--valid {
		background: #d9efda;
	}

	&--horizontal-row {
		padding: 20px 0 0;
		position: relative;

		&:before {
			content: "";
			position: absolute;
			height: 4px;
			left: 0;
			right: 0;
			top: 0;
			background: #f5f5f5;
			border-radius: 10px;
		}
	}
}

@media only screen and (max-width: 725px) {
	.configurator-step--validstate {
		.configurator-step__title {
			font-size: 1.8rem;
			flex-wrap: wrap;
			padding: 12px;
		}

		.configurator-step__item {
			width: 100%;
			margin-top: -2px;
			padding-left: 26px;
		}
	}
}

@media only screen and (max-width: 480px) {
	.configurator-step--active .configurator-step__not-active-mobile {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/step/step.vue